import { CreateFocusCss, isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { ModalBodyProps } from '..'

export default (config: {
  props: Pick<ModalBodyProps, 'noPadding'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      body: {
        paddingInline: props.noPadding ? 0 : tokens.spacingGap400,

        [isPhoneInLandscape]: {
          paddingInline: props.noPadding ? 0 : tokens.spacingGap200,
        },
      },

      shadowTop: {
        display: 'block',
        borderBottom: '1px solid',
        borderColor: 'transparent',
        opacity: 1,
      },

      shadowBottom: {
        display: 'block',
        borderTop: '1px solid',
        borderColor: 'transparent',
        opacity: 1,
      },
    },

    scrollShadow: {
      bodyWrap: {
        ...CreateFocusCss(tokens.focusInner),
      },
    },
  } as const
}
